var render = function render(){var _vm=this,_c=_vm._self._c;return _c('el-dialog',{attrs:{"title":"详情","visible":_vm.state,"width":"50%","before-close":_vm.handleClose},on:{"update:visible":function($event){_vm.state=$event}}},[_c('div',[_c('TzTable',{attrs:{"height":300,"tableData":_vm.pageList,"columns":_vm.columnsEdit}})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }